import { useContext, useState } from "react";
import ResearchCommentForm03 from "./ResearchCommentForm03";
import ResearchCommentList03 from "./ResearchCommentList03";
import { AuthContext } from "../../../../context/AuthProvider";

const ResearchComment03 = ({
  board,
  boardItem,
  replyMode,
  setReplyMode,
  className = "",
}) => {
  const { isAdmin } = useContext(AuthContext);

  const [selectComment, setSelectComment] = useState(null);

  return !!board?.options?.useComment ? (
    <div
      className={`flex flex-col md:gap-10 gap-4 pt-10 border-t border-gray-border ${className}`}
    >
      <ResearchCommentList03
        board={board}
        boardItem={boardItem}
        selectComment={selectComment}
        setReplyMode={setReplyMode}
        setSelectComment={setSelectComment}
      />

      <div id="reply-form">
        {isAdmin && (replyMode || selectComment?.commentNo) ? (
          <ResearchCommentForm03
            board={board}
            boardItem={boardItem}
            selectComment={selectComment}
            setReplyMode={setReplyMode}
            setSelectComment={setSelectComment}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  ) : null;
};

export default ResearchComment03;
